import { Home, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NaoEncontrado = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="text-center max-w-md mx-auto">
        {/* Dente Emoji Caricato */}
        <div className="mb-8 relative">
          {/* Dente base */}
          <div className="text-9xl mb-4">🦷</div>

          {/* Sobreposição com rosto triste */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative top-0">
              {/* Olhos tristes */}
              <div className="flex justify-center gap-6 mb-4">
                <div className="w-4 h-6 bg-black rounded-full relative">
                  <div className="w-2 h-2 bg-white rounded-full absolute top-1 left-1"></div>
                </div>
                <div className="w-4 h-6 bg-black rounded-full relative">
                  <div className="w-2 h-2 bg-white rounded-full absolute top-1 left-1"></div>
                </div>
              </div>

              {/* Boca triste de ponta cabeça */}
              <div className="flex justify-center">
                <div className="w-8 h-4 border-t-4 border-black rounded-t-full"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Texto 404 */}
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>

        {/* Mensagem */}
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">
          Página não encontrada
        </h2>
        <p className="text-gray-600 mb-8">
          A página que você está procurando não existe ou foi removida.
        </p>

        {/* Botões */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <ArrowLeft size={20} />
            Voltar
          </button>

          <button
            onClick={() => navigate("/")}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <Home size={20} />
            Ir para o Início
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaoEncontrado;
